import React, { useEffect, useRef, useState } from "react";

const whyChooseUs = [
  { icon: "🏆", title: "தரமான பொருட்கள்", sub: "Quality Products", desc: "Only genuine, branded products from authorized distributors." },
  { icon: "📦", title: "பரந்த தேர்வு", sub: "Wide Range", desc: "500+ products across audio, electrical, home & commercial categories." },
  { icon: "🤝", title: "நம்பகமான சேவை", sub: "Trusted Service", desc: "40+ years of trust with thousands of happy customers." },
  { icon: "🚚", title: "உடனடி டெலிவரி", sub: "Fast Delivery", desc: "Quick local delivery across Peraiyur and nearby areas." },
  { icon: "🏅", title: "அரசு அங்கீகாரம்", sub: "Govt. Certified", desc: "Officially registered business — GSTIN: 33CWKPM2326M1ZB." },
  { icon: "👨‍🔧", title: "அனுபவம் மிக்க உரிமையாளர்", sub: "Expert Ownership", desc: "Directly run by the proprietor, ensuring personal attention to every customer." },
];

const stats = [
  { number: "40+",   label: "Years of Legacy",    tamil: "வருட பாரம்பரியம்", icon: "📅" },
  { number: "500+",  label: "Products",            tamil: "பொருட்கள்",        icon: "📦" },
  { number: "20+",   label: "Top Brands",          tamil: "பிராண்டுகள்",      icon: "🏷️" },
  { number: "5000+", label: "Happy Customers",     tamil: "வாடிக்கையாளர்கள்", icon: "😊" },
];


export const About = (props) => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" ref={sectionRef} className={visible ? "in-view" : ""}>
      <div className="container">

        {/* ── PART 1: Image + Intro ── */}
        <div className="row about-row">

          {/* Image */}
          <div className="col-md-6 about-img-col">
            <div className="about-img-frame">
              <img
                src="/img/s3.png"
                alt="Gurunathan Electronics shop, Usilampatti Road, Peraiyur"
                className="about-img"
              />
              <div className="about-img-badge">
                <span className="badge-number">40+</span>
                <span className="badge-text">Years of Legacy</span>
              </div>
            </div>
            <div className="about-owner">
              <img src="/img/logo.png" alt="Logo" className="owner-logo" />
              <div>
                <strong>திருமதி. முருகேஸ்வரி கார்த்திக்</strong>
                <span>Proprietor — Gurunathan Electronics</span>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="col-md-6 about-text-col">

            <div className="govt-badge">
              🏅 அரசு அங்கீகாரம் பெற்ற நிறுவனம்
              <span className="gstin">GSTIN: 33CWKPM2326M1ZB</span>
            </div>

            <h2><span>About Us</span></h2>
            <hr style={{ margin: "0 10px 20px", width: "70px" }} />

            <p className="about-lead">
              உங்கள் இல்லம் மற்றும் தொழிலுக்குத் தேவையான மின்னணு
              சாதனங்களின் முழுமையான சந்தை.
            </p>

            <p>
              Our family's business journey began in <strong>1984</strong>, when
              our founder <strong>Mr. A. Ku. Ma. Ramalingam</strong>, a respected
              agriculturist, built a strong foundation in Electricals &amp;
              Hardware. His sons, <strong>Mr. Nagarajan Ramalingam</strong> and{" "}
              <strong>Mr. Kannan Ramalingam</strong>, grew into successful
              entrepreneurs in the same industry.
            </p>
            <p>
              Among them, Mr. Nagarajan Ramalingam began his entrepreneurial journey at the young age of nine, growing alongside the people and market of Peraiyur. Through unwavering dedication, perseverance, and years of practical experience, he mastered the trade and built a successful business based on trust and customer satisfaction.
            </p>
            <p>Built on <span>Quality • Trust • Service</span></p>
          </div>
        </div>

        {/* ── PART 2: Stats ── */}
        <div className="about-stats-row">
          {stats.map((s, i) => (
            <div className="about-stat-card" key={i} style={{ animationDelay: `${i * 0.12}s` }}>
              <div className="stat-icon">{s.icon}</div>
              <div className="stat-number">{s.number}</div>
              <div className="stat-label">{s.label}</div>
              <div className="stat-tamil">{s.tamil}</div>
            </div>
          ))}
        </div>

        {/* ── PART 3: Horizontal/Vertical Timeline ── */}
<div className="generation-section">
  <div className="section-title text-center">
    <h2><span>Our Legacy</span></h2>
    <p>வளர்ச்சியின் மைல்கற்கள் — 3 தலைமுறைகள், ஒரே நம்பிக்கை</p>
  </div>

  <div className="hv-timeline">
    <div className="hv-track">

      <div className="hv-item">
        <div className="hv-item-inner">
          <div className="hv-year">1984</div>
          <div className="hv-content">
                      <div className="hv-dot" />
            <span className="hv-icon">🌱</span>
            <h4 className="hv-title">The Foundation</h4>
            <p className="hv-tamil">தொடக்கம்</p>
            <p className="hv-desc">
  Mr. A. Ku. Ma. Ramalingam established the family's
  Electricals &amp; Hardware business. Mr. Nagarajan Ramalingam began
  his journey at just <strong>nine years old</strong>, growing
  alongside the people and market of Peraiyur.
</p>
          </div>
        </div>
      </div>

      <div className="hv-item">
        <div className="hv-item-inner">
          <div className="hv-year">2018</div>
          <div className="hv-content">
                      <div className="hv-dot" />
            <span className="hv-icon">📈</span>
            <h4 className="hv-title">Next Generation</h4>
            <p className="hv-tamil">அடுத்த தலைமுறை</p>
            <p className="hv-desc">
  Mr. Prathap expanded the business with modern
  practices — adapting to Peraiyur's evolving
  market needs. He introduced <strong>modern business
  practices</strong>, expanding the family's reach further.
</p>
          </div>
        </div>
      </div>

      <div className="hv-item">
        <div className="hv-item-inner">
          <div className="hv-year">2026</div>
          <div className="hv-content">
            <div className="hv-dot" />
            <span className="hv-icon">⚡</span>
            <h4 className="hv-title">Gurunathan Electronics</h4>
            <p className="hv-tamil">குருநாதன் எலக்ட்ரான்னிக்ஸ்</p>
<p className="hv-desc">
  Mrs. Murugeshwari Karthick, daughter of Mr. Nagarajan Ramalingam, is the <strong>third-generation
  successor</strong> who established Gurunathan Electronics
  a dedicated <strong>Electronics division</strong> built on
  innovation, quality &amp; customer satisfaction.
</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<div className="legacy-closing">
  <div className="legacy-left">
    <p className="legacy-left-title">Our Promise</p>
    <div className="legacy-quote">
      Building on Tradition,<br />
      Powered by Trust,<br />
      Committed to Excellence.
      <span>— Gurunathan Electronics</span>
    </div>
    <div className="legacy-values">
      <div className="legacy-value-pill">Honesty</div>
      <div className="legacy-value-pill">Hard Work</div>
      <div className="legacy-value-pill">Commitment</div>
    </div>
  </div>

  <div className="legacy-right">
    <p className="legacy-right-heading">Four Decades of Trust</p>
    <p>
      For over four decades, every generation of our family has carried
      forward the values of <strong>honesty, hard work, and commitment</strong> established
      by our founder. As we continue to grow, your trust remains our
      greatest strength — our most valuable asset.
    </p>
    <hr className="legacy-divider" />
    <p className="legacy-final-line">
      குருநாதன் எலக்ட்ரான்னிக்ஸ் —{" "}
      <span>உங்கள் வணிக வளர்ச்சியே எங்களின் வெற்றி.</span>
    </p>
  </div>
</div>

        {/* ── PART 4: Why Choose Us ── */}
        <div className="why-section">
          <div className="section-title text-center">
            <h2><span>Why Choose Us ?</span></h2>
            <p>ஏன் எங்களை தேர்ந்தெடுக்கணும்?</p>
          </div>
          <div className="why-grid">
            {whyChooseUs.map((w, i) => (
              <div className="why-card" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                <div className="why-icon">{w.icon}</div>
                <div className="why-content">
                  <h4 className="why-title">{w.title}</h4>
                  <p className="why-sub">{w.sub}</p>
                  <p className="why-desc">{w.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};